export default __webpack_public_path__ + "static/media/tron-trx-logo.e3aaf062.svg";